import { graphql, useStaticQuery } from 'gatsby';
import * as React from 'react';

import { Stripes1View } from './careers-benefits-stripes1.view';

export const Stripes1 = () => {
  const { stripes } = useStaticQuery(graphql`
    query {
      stripes: file(relativePath: { eq: "pages/careers/benefits/careers-benefits-stripes1.svg" }) {
        publicURL
      }
    }
  `);

  return <Stripes1View imageSrc={stripes.publicURL} />;
};
